type Targetunit = 'b' | 'kb' | 'mb' | 'gb';
export function convertFileSize(
  value: number,
  fromUnit: Targetunit,
  toUnit: Targetunit
): number {
  const kilobyte = 1024;
  const megabyte = kilobyte * 1024;
  const gigabyte = megabyte * 1024;

  const units: Record<string, number> = {
    b: 1,
    kb: kilobyte,
    mb: megabyte,
    gb: gigabyte,
  };

  if (!(fromUnit.toLowerCase() in units) || !(toUnit.toLowerCase() in units)) {
    throw new Error('Invalid units. Please use B, KB, MB, or GB.');
  }

  const bytes = value * units[fromUnit.toLowerCase()];
  return bytes / units[toUnit.toLowerCase()];
}
